import 'rxjs';
import { Observable } from 'rxjs/Observable';
import actions, { LOAD_FREELANCERS } from '../actions';

const loadFreelancersEpic = (action$, store, { api }) =>
    action$.ofType(LOAD_FREELANCERS).mergeMap(action =>
        Observable.from(api.fetchFreelancers(action.payload))
            .map(response => actions.loadFreelancerSuccess(response.data))
            .catch(() =>
                Observable.of(
                    actions.loadFreelancerFailure(
                        'Problem loading freelancers',
                    ),
                ),
            ),
    );

export default loadFreelancersEpic;
